/***
 *
 *   HELP
 *   Information for user to get help and support
 *
 **********/

import { Fragment, memo, useEffect } from "react";
import { Card, Form, Row, Alert, Loader, useAPI } from "components/lib";

export function Help({ t }) {
  const user = useAPI("/api/user");

  // Prevent horizontal scroll on mount
  useEffect(() => {
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflowX = 'hidden';
    return () => {
      document.body.style.overflowX = 'auto';
      document.documentElement.style.overflowX = 'auto';
    };
  }, []);

  return (
    <div className="min-h-screen w-full overflow-x-hidden" style={{ maxWidth: '100vw' }}>
      <div 
        className="py-3 w-full box-border px-6 sm:px-6 sm:pr-6 overflow-x-hidden"
        style={{ 
          width: window.innerWidth < 640 ? 'calc(100vw - 24px)' : 'calc(100vw - 256px - 24px)',
          maxWidth: window.innerWidth < 640 ? 'calc(100vw - 24px)' : 'calc(100vw - 256px - 24px)'
        }}
      >
        <Fragment>
          <Row width="lg">
            <Card>
              <div className="text-center space-y-2">
                <h1 className="text-2xl sm:text-3xl font-light text-white fade-in tracking-wide">
                  {t("help.message.title")}
                </h1>
                <p className="text-white/60 text-sm font-light slide-up" style={{animationDelay: '0.1s'}}>
                  {t("help.message.description")}
                </p>
              </div>
            </Card>
          </Row>

          {user.loading ? (
            <Loader />
          ) : (
            <Row width="lg">
              <Card title={t("help.subtitle")}>
                <EnableSupport t={t} enabled={user.data?.support_enabled} />

                <Row>
                  <Form
                    inputs={{
                      email: {
                        type: "hidden",
                        value: user?.data?.email,
                      },
                      name: {
                        type: "hidden",
                        value: user?.data?.name,
                      },
                      template: {
                        type: "hidden",
                        value: "help",
                      },
                      message: {
                        type: "textarea",
                        label: t("help.form.message.label"),
                        errorMessage: t("help.form.message.error"),
                        required: true,
                      },
                    }}
                    method="POST"
                    url="/api/utility/mail"
                    buttonText={t("help.form.button")}
                  />
                </Row>
              </Card>
            </Row>
          )}
        </Fragment>
      </div>
    </div>
  );
}

const EnableSupport = memo(function Enable2FA({ enabled, t, callback }) {
  return (
    <Row>
      <Form
        inputs={{
          support_enabled: {
            type: "switch",
            defaultValue: enabled,
            label: t("help.form.support_enabled.label"),
          },
        }}
        submitOnChange
        method="PATCH"
        url="/api/user"
      />
    </Row>
  );
});
